/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';

import { IconFacade } from '@atlaskit/icon/base';
import type { GlyphProps } from '@atlaskit/icon/types';

const PageLiveDoc16Icon = (props: Omit<GlyphProps, 'primaryColor' | 'secondaryColor' | 'size'>) => (
	<IconFacade
		dangerouslySetGlyph={`<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`}
		// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
		{...props}
		size="small"
	/>
);

PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default PageLiveDoc16Icon;
